import { connect } from 'react-redux';
import Modal from 'comp/modals/remove_member';
import * as selectors from 'selectors';
import { cache } from 'utils';

const mapToProps = state => ({
  status: state.fetch.group_remove_member || cache.empty_obj,
  conv_id: selectors.getSelectedConvId(),
  member_id: state.ui.selected_member
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/RemoveMember.js